import {
  DM_Sans,
  IBM_Plex_Sans,
  Libre_Baskerville,
  Outfit,
  Source_Serif_4,
} from "next/font/google";
import type { BrandFontId } from "@/lib/branding";

const outfit = Outfit({
  subsets: ["latin"],
  weight: ["400", "500", "600", "700"],
  variable: "--font-outfit",
});

const dmSans = DM_Sans({
  subsets: ["latin"],
  weight: ["400", "500", "600", "700"],
  variable: "--font-dm-sans",
});

const ibmPlexSans = IBM_Plex_Sans({
  subsets: ["latin"],
  weight: ["400", "500", "600", "700"],
  variable: "--font-ibm-plex-sans",
});

const libreBaskerville = Libre_Baskerville({
  subsets: ["latin"],
  weight: ["400", "700"],
  variable: "--font-libre-baskerville",
});

const sourceSerif4 = Source_Serif_4({
  subsets: ["latin"],
  weight: ["400", "500", "600", "700"],
  variable: "--font-source-serif-4",
});

const FONT_CLASS: Record<BrandFontId, string> = {
  outfit: outfit.className,
  "dm-sans": dmSans.className,
  "ibm-plex-sans": ibmPlexSans.className,
  "libre-baskerville": libreBaskerville.className,
  "source-serif-4": sourceSerif4.className,
};

export const brandFontVariableClass = [
  outfit.variable,
  dmSans.variable,
  ibmPlexSans.variable,
  libreBaskerville.variable,
  sourceSerif4.variable,
].join(" ");

export function brandFontClass(fontFamily: BrandFontId): string {
  return FONT_CLASS[fontFamily] ?? outfit.className;
}
